export const DESIGNER_PERFORMANCE_FLAG_NAMES = {
  // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-dperf-36-component-migration-lock
  COMPONENT_MIGRATION_LOCK: 'ff-dperf-36-component-migration-lock',
  // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-dperf-177-migration-lock-for-branched-sites
  ENABLE_BRANCHED_COMPONENT_MIGRATION:
    'ff-dperf-177-migration-lock-for-branched-sites',
  // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-dperf-143-components-migration-killswitch
  COMPONENTS_MIGRATION_KILLSWITCH:
    'ff-dperf-143-components-migration-killswitch',
  // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-dperf-236-enable-precise-components
  ENABLE_PRECISE_COMPONENTS: 'ff-dperf-236-enable-precise-components',
  // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-dperf-555-sharded-migration-killswitch
  SHARDED_MIGRATION_KILLSWITCH: 'ff-dperf-555-sharded-migration-killswitch',
  // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-crashm-1419-designer-diagnostics-reporting
  CRASH_MODAL: 'ff-crashm-1419-designer-diagnostics-reporting',
  // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-dperf-350-sharded-styles-new-sites
  ENABLE_STYLES_SHARDING: 'ff-dperf-350-sharded-styles-new-sites',
  // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-dperf-614-sharded-interactions-new-sites
  ENABLE_INTERACTIONS_SHARDING: 'ff-dperf-614-sharded-interactions-new-sites',
  // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-dperf-798-flux-detailed-metrics
  FLUX_DETAILED_METRICS: 'ff-dperf-798-flux-detailed-metrics',
  SNAPSHOT_DECOUPLE_DBITEMS_OPTIMIZATION:
    'ff-dperf-963-snapshot-decouple-dbitems-optimization',
  TAG_SELECT_MIGRATION: 'ff-dperf-tagselect-migration',
  // https://console.statsig.com/7kzGQWd4hVXvdCs5dNkqUB/gates/ff-dsys-7058-memory-crash-observability
  MEMORY_CRASH_OBSERVABILITY: 'ff-dsys-7058-memory-crash-observability',
  DEFER_NAVIGATOR_DRAG_VALIDATION: 'ff-des-7579-navigator-dnd-perf',
  FASTER_ASSET_SEARCH: 'ff-des-7755-faster-asset-search',
  FAST_COPY: 'ff-designer-fast-copy',
  DESIGNER_OMIT_HIDDEN_ELEMENTS: 'ff-designer-omit-hidden-elements',
};
